// extracted by mini-css-extract-plugin
export default {"question":"_8e4c6176","arrowIcon":"_615f34a"};